import { render } from "./SidebarDropdownLinks.vue?vue&type=template&id=027c5925&scoped=true"
import script from "./SidebarDropdownLinks.vue?vue&type=script&lang=js"
export * from "./SidebarDropdownLinks.vue?vue&type=script&lang=js"

import "./SidebarDropdownLinks.vue?vue&type=style&index=0&id=027c5925&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027c5925"]])

export default __exports__